import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './components/App'

export let startLtiLogs = userId => {
  const root = createRoot(document.getElementById('ltiLogsApp'))
  root.render(<App userId={userId} />)
}
